import { API } from "aws-amplify";

export const getKey = async () => {
  try {
    return await API.get("account-api", "/auth/events");
  } catch (e) {
    return console.log(e.message);
  }
};
